export function SunRoofGlyph({ pitch = 27 }: { pitch?: number }) {
  const rad = (pitch * Math.PI) / 180;
  const run = 150;
  const rise = Math.tan(rad) * run;
  const apexX = 40 + run;
  const apexY = 150 - rise;

  return (
    <svg
      data-testid="sun-roof-glyph"
      viewBox="0 0 340 170"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="h-full w-full text-energy"
      aria-hidden
    >
      <circle cx="260" cy="52" r="20" />
      {Array.from({ length: 8 }, (_, i) => {
        const a = (i * Math.PI) / 4;
        const x1 = 260 + Math.cos(a) * 28, y1 = 52 + Math.sin(a) * 28;
        const x2 = 260 + Math.cos(a) * 38, y2 = 52 + Math.sin(a) * 38;
        return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} />;
      })}
      <path d={`M40 150 L${apexX} ${apexY}`} strokeWidth="2.2" />
      <path d={`M${apexX} ${apexY} L${apexX + 60} 150`} strokeWidth="2.2" />
      <path d="M40 150 H300" className="text-cad" strokeDasharray="3 5" />
      <path d={`M40 150 L100 150 A60 60 0 0 0 ${40 + 60 * Math.cos(rad)} ${150 - 60 * Math.sin(rad)}`} className="text-cad" />
      <text x="110" y="142" fill="#475569" stroke="none" fontSize="13" fontFamily="JetBrains Mono, monospace">
        {pitch}°
      </text>
      {[0, 1, 2].map((i) => (
        <line key={i} x1={232 - i * 22} y1={78 + i * 16} x2={218 - i * 22} y2={92 + i * 16} strokeDasharray="2 4" />
      ))}
    </svg>
  );
}
